<template>
  <card-wrapper>
    <div class="columns">
      <div class="column is-8-desktop is-offset-2-desktop is-12-tablet">
        <div class="card">
          <div class="card-header">
            <div class="card-header-title">{{ title }}</div>
          </div>
          <div class="card-content">
            <loader :state="state">
              <dynamic-content :content="policy" />

              <template #loading>
                <div
                  class="spinner is-3by4 is-grey-lighter is-thick is-large is-centered"
                ></div>
              </template>

              <template #error>
                <div class="grey-message">
                  <icon name="fa-times-circle" />
                  <p>Dane niedostępne z powodu braku połączenia z serwerem.</p>
                </div>
              </template>
            </loader>
          </div>
        </div>
      </div>
    </div>
  </card-wrapper>
</template>

<script>
import { CardWrapper, DynamicContent, Loader, Icon } from "%helpers";

export default {
  name: "policy",

  components: {
    CardWrapper,
    DynamicContent,
    Loader,
    Icon
  },

  props: {
    title: String,
    policy: String,
    state: [String, Array]
  }
};
</script>

<style></style>
